import React, { useState, Fragment, useEffect } from "react";
import { LoginCodeForm } from "./Form";
import { useLayoutHeader } from "components/MainLayout";
import { Row, Col } from "antd";
import { getAuthApi } from "api";
import { useHistory } from "react-router";
import routesConfig from "../../../routesConfig";
import { message } from "antd";
import Typography from "antd/es/typography";
import { fixNumbers } from "utils";

const headerConfig = {
	pageTitle: "کد فعالسازی",
	closeable: true,
	menuEnabled: false,
	extra: [],
};

export const LoginCodeFormContainer = ({ codeKey, onVerifySuccess,timer, setTimer }) => {
	const { Title } = Typography;
	useLayoutHeader(headerConfig);
	const [{ loading, submitting, failed }, setState] = useState({ loading: false, submitting: false, failed: false });
	const [verificationCode, setVerificationCode] = useState("");
	const history = useHistory();
	const backToLogin = () => history.push(routesConfig.login);
	const onFinish = ({ code }) => {
		setState({ submitting: true });
		code = verificationCode + "";

		getAuthApi()
			.verifyAuthCode({ code: fixNumbers(code), codeKey })
			.then((res) => {
				if (onVerifySuccess) {
					onVerifySuccess(res);
				}
			})
			.catch((error) => {
				console.error(error);
				setState({ submitting: false, failed: true });
			});
	};
	const retransmitVerificationCode = () => {
		const phone = codeKey;
		getAuthApi()
			.requestAuthCode({ phone })
			.then((res) => message.success("کد با موفقیت به شماره " + phone + "ارسال شد."))
			.catch((error) => message.error("کد ارسال نشد دوباره تلاش کنید!!"));
	};

	const onChange = () => {
		setState({ failed: false });
	};

	useEffect(() => {
		timer && setTimeout(() => setTimer((perValue) => (perValue ? perValue - 1 : 0)), 1000);
	}, [timer]);

	return (
		<Fragment>
			<Row>
				<Col span={24} className="px-40">
					<Title level={2} className="f-30 mb-36">
						ورود کد فعال سازی
					</Title>
				</Col>
				<Col span={24} className="px-40">
					<LoginCodeForm
						timer={timer}
						onFinish={onFinish}
						onChange={onChange}
						loading={loading}
						submitting={submitting}
						failed={failed}
						setVerificationCode={setVerificationCode}
						codeKey={codeKey}
						backToLogin={backToLogin}
						retransmitVerificationCode={retransmitVerificationCode}
					/>
				</Col>
			</Row>
		</Fragment>
	);
};

export default LoginCodeFormContainer;
